export default function buildAdminAssetsQuery(searchParams) {
  const params = new URLSearchParams(
    typeof searchParams === "string" ? searchParams : searchParams?.toString?.() || ""
  );
  const q = new URLSearchParams();

  const make = params.get("make")?.trim();
  if (make) q.set("make", make);

  const model = params.get("model")?.trim();
  if (model) q.set("model", model);

  const assetType = params.get("asset_type");
  if (assetType && ["internal", "external", "all"].includes(assetType)) {
    if (assetType !== "all") q.set("asset_type", assetType);
  }

  return q.toString();
}
